import React from "react";
import "./style.scss";

export default function TermsOfUse() {
    return (
        <div className="terms-container">
            <h1>Keeta Brand Assets Terms and Conditions</h1>
            <div className="terms-content">
                <p>
                    Welcome to Keeta Brand Assets (the "Platform"). These Terms
                    of Use ("Terms") outline the rules and conditions governing
                    your access to and use of the Platform, including all
                    content, tools, and resources provided herein. These Terms
                    will also apply to the use of affiliate brands of Keeta on
                    the Platform, including but not limited to Meituan, Keemat
                    by Keeta, Keeta Drone. By accessing or using the Platform,
                    you consent to be bound by these Terms. If you do not agree,
                    please refrain from using the Platform.
                </p>
                <ol>
                    <li>
                        <strong> 1. Acceptance of Terms</strong>
                        <p>
                            These Terms form a legally binding contract between
                            you ("User", "you", or "your") and Keeta ("we",
                            "us", or "our"), the owner and operator of the
                            Platform. We reserve the right to update or modify
                            these Terms at any time, with changes effective upon
                            posting to the Platform. Your continued use of the
                            Platform after such changes constitutes acceptance
                            of the updated Terms. We encourage you to review
                            these Terms periodically.
                        </p>
                    </li>
                    <li>
                        <strong> 2. Purpose of the Platform</strong>
                        <p>
                            The Platform provides access to Keeta's brand
                            assets, including logos, typography, color palettes,
                            images, guidelines, and other materials
                            (collectively, "Brand Assets"). These resources are
                            intended for use by authorized individuals,
                            partners, employees, or third parties in accordance
                            with our requirements and instructions to promote
                            consistency and integrity in presenting Keeta.
                        </p>
                    </li>
                    <li>
                        <strong> 3. Eligibility</strong>
                        <p>
                            To access the Platform, you must be at least the
                            legal age and have the legal capacity to enter into
                            binding agreements. If you are accessing the
                            Platform on behalf of an organization, you affirm
                            that you have the authority to commit that
                            organization to abide by these Terms. We reserve the
                            right to refuse access to any User at our sole
                            discretion.
                        </p>
                    </li>
                    <li>
                        <strong> 4. License to Use Brand Assets</strong>
                        <ol>
                            <li>
                                <span>4.1 Grant of License</span>
                                <p>
                                    Provided you adhere to these Terms, we grant
                                    you a limited, non–exclusive,
                                    non–transferable, revocable license to
                                    access, download, and use the Brand Assets
                                    solely for purposes of your collaboration
                                    with Keeta. Examples of permitted use
                                    include marketing materials, presentations,
                                    or campaigns explicitly approved in writing
                                    by Keeta
                                </p>
                            </li>
                            <li>
                                <span>4.2 Restrictions</span>
                                <ul>
                                    <li>You may not: </li>
                                    <li>
                                        · Modify, alter, or create derivative
                                        works of the Brand Assets without prior
                                        written consent, except as expressly
                                        permitted by Keeta.
                                    </li>
                                    <li>
                                        · Sublicense, sell, rent, or distribute
                                        the Brand Assets to third parties
                                        without explicit written approval.
                                    </li>
                                    <li>
                                        · Use the Brand Assets in a manner that
                                        implies endorsement, affiliation, or
                                        sponsorship by Keeta beyond your
                                        authorized scope.
                                    </li>
                                    <li>
                                        · Use the Brand Assets in any illegal,
                                        defamatory, or misleading way, or in
                                        connection with obscene, offensive, or
                                        harmful content.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <span>4.3 Ownership</span>
                                <p>
                                    All Brand Assets, including associated
                                    intellectual property rights (e.g.,
                                    trademarks, copyrights), remain the sole
                                    property of the owner. These Terms do not
                                    transfer any ownership rights to you.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong> 5. User Accounts</strong>
                        <ol>
                            <li>
                                <span>5.1 Registration</span>
                                <p>
                                    Certain features of the Platform may require
                                    you to create an account. You agree to
                                    provide accurate, current, and complete
                                    information during registration and to keep
                                    your account details updated.
                                </p>
                            </li>
                            <li>
                                <span>5.2 Security</span>
                                <p>
                                    You are responsible for maintaining the
                                    confidentiality of your account credentials
                                    (e.g., username, password) and for all
                                    activities under your account. Notify us
                                    immediately at [
                                    <a
                                        href="mailto:brand@keetainc.com"
                                        style={{ color: "#166FF7" }}
                                        target="_blank" rel="noreferrer"
                                    >
                                        brand@keetainc.com
                                    </a>
                                    ] if you suspect unauthorized use of your
                                    account. We are not liable for any loss or
                                    damage arising from your failure to secure
                                    your account.
                                </p>
                            </li>
                            <li>
                                <span>5.3 Termination of Access</span>
                                <p>
                                    We may suspend or terminate your account or
                                    access to the Platform at our discretion,
                                    with or without notice, for reasons
                                    including but not limited to violation of
                                    these Terms, suspected misuse of Brand
                                    Assets, or inactivity.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong> 6. User Conduct</strong>

                        <ul>
                            <li>
                                You agree to use the Platform and Brand Assets
                                responsibly and in compliance with applicable
                                laws. Prohibited actions include:
                            </li>
                            <li>
                                · Attempting unauthorized access to the
                                Platform, its systems, or other Users' accounts.
                            </li>
                            <li>
                                · Engaging in data scraping, harvesting, or
                                automated collection of content without our
                                prior written consent.
                            </li>
                            <li>
                                · Uploading any material that infringes on the
                                copyright, trademark, or other intellectual
                                property rights of third parties, whether
                                knowingly or unknowingly. Users are strictly
                                prohibited from submitting copyright-infringing
                                material to the Platform.
                            </li>
                            <li>
                                · Uploading or sharing content that is sexually
                                explicit, promotes violence, or encourages the
                                use of alcohol or other substances, as
                                determined in our sole discretion.
                            </li>
                            <li>
                                · Using the Platform for any purpose not
                                expressly permitted by these Terms.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong> 7. Intellectual Property</strong>
                        <ol>
                            <li>
                                <span>7.1 Our Rights</span>
                                <p>
                                    The Platform, Brand Assets, and all
                                    associated content (e.g., text, graphics,
                                    software) are protected by copyright,
                                    trademark, and other intellectual property
                                    laws. Except as provided in Section 4, you
                                    have no rights to our intellectual property.
                                </p>
                            </li>
                            <li>
                                <span>7.2 User Submissions</span>
                                <p>
                                    By uploading content to the Platform (e.g.,
                                    feedback, designs, images, or other
                                    materials), you irrevocably grant and
                                    license us to use the contents on a royalty
                                    free basis and agree that we could
                                    sublicense others to use the content. We may
                                    use or sublicense others to use, reproduce,
                                    modify, distribute, and create derivative
                                    works from this content worldwide,
                                    royalty-free, and in perpetuity, for any
                                    purpose related to the business operation of
                                    Keeta or operating, promoting, or improving
                                    the Platform. Upon upload, you relinquish
                                    any claim to intellectual property rights.
                                    You represent and warrant that you have the
                                    legal right to transfer such intellectual
                                    property rights and that the content does
                                    not infringe on any third-party rights,
                                    including copyrights. 
                                </p>
                            </li>
                            <li>
                                <span>7.3 Trademark Use</span>
                                <p>
                                    Use of Keeta trademarks requires prior
                                    approval unless otherwise specified.
                                    Unauthorized use may result in legal action
                                    to protect our rights.
                                </p>
                            </li>
                            <li>
                                <span>7.4 User-Generated Content</span>
                                <p>
                                    We do not pre-screen or monitor content
                                    uploaded by Users. You acknowledge that any
                                    material you upload is your sole
                                    responsibility. If you upload content that
                                    infringes on third-party rights (e.g.,
                                    copyright) or violates these Terms (e.g.,
                                    sexual, violent), we may remove it at our
                                    discretion without notice. We are not liable
                                    for any such content, whether uploaded
                                    knowingly or unknowingly, and we do not
                                    endorse or promote it. To the extent
                                    permitted by law, we comply with applicable
                                    copyright laws. To report infringing
                                    material, contact us at [
                                    <a
                                        href="mailto:brand@keetainc.com"
                                        style={{ color: "#166FF7" }}
                                        target="_blank" rel="noreferrer"
                                    >
                                        brand@keetainc.com
                                    </a>
                                    ] with the required details (e.g.,
                                    identification of the work, your contact
                                    information, the proof of ownership of
                                    intellectual property rights and a statement
                                    of good faith belief).
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong> 8. Privacy</strong>
                        <p>
                            Your use of the Platform is also governed by our
                            Privacy Policy[
                            <a
                                href="https://www.mykeeta.com/contents/en/privacy.html"
                                style={{ color: "#166FF7" }}
                                target="_blank" rel="noreferrer"
                            >
                                https://www.mykeeta.com/contents/en/privacy.html
                            </a>
                            ] ,which outlines how we collect, use, and protect
                            your personal information. By using the Platform,
                            you consent to such processing as described therein.
                        </p>
                    </li>
                    <li>
                        <strong> 9. Disclaimer</strong>
                        <ol>
                            <li>
                                <span>9.1 As-Is Basis</span>
                                <p>
                                    The Platform and Brand Assets are offered on
                                    an “as is” and “as available,” without
                                    warranties of any kind, express or implied,
                                    including but not limited to warranties of
                                    merchantability, fitness for a particular
                                    purpose, or non-infringement.
                                </p>
                            </li>
                            <li>
                                <span>9.2 No Guarantee</span>
                                <p>
                                    We do not guarantee that the Platform will
                                    be free from interruptions, errors, or
                                    security issues, or that the Brand Assets
                                    will meet your specific needs. Technical
                                    issues may occur, and we are under no
                                    obligation to provide support unless
                                    otherwise agreed.
                                </p>
                            </li>
                            <li>
                                <span>9.3 No Liability for User Content</span>
                                <p>
                                    We disclaim all liability for content
                                    uploaded by Users, including but not limited
                                    to material that infringes on intellectual
                                    property rights or is sexual, violent,
                                    alcohol-enticing or otherwise objectionable.
                                    Such content does not represent our views,
                                    and we do not encourage, support, or condone
                                    its distribution. We reserve the right to
                                    remove any content that violates these Terms
                                    or applicable law, but we are not obligated
                                    to do so unless required by law.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong> 10. Limitation of Liability</strong>
                        <p>
                            To the fullest extent permitted by law, Keeta, its
                            affiliates, officers, directors, employees, and
                            agents shall not be liable for any indirect,
                            incidental, consequential, or punitive damages
                            arising from your use of the Platform or Brand
                            Assets. This includes, but is not limited to,
                            damages for loss of profits, data, or goodwill, even
                            if we were advised of the possibility of such
                            damages. Our total liability, if any, will not
                            exceed $100 USD.
                        </p>
                    </li>
                    <li>
                        <strong> 11. Indemnification</strong>
                        <ul>
                            <li>
                                You agree to indemnify, defend, and hold
                                harmless Keeta and its affiliates from any
                                claims, losses, damages, or expenses (including
                                legal fees) arising from:
                            </li>
                            <li>· Your violation of these Terms.</li>
                            <li>
                                · Your misuse of the Platform or Brand Assets.
                            </li>
                            <li>
                                · Your upload of content that infringes on
                                third-party rights (e.g., copyright, trademark)
                                or contains sexual, violent, or alcohol-enticing
                                material, whether uploaded knowingly or
                                unknowingly.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong> 12. Termination</strong>
                        <ol>
                            <li>
                                <span>12.1 By You</span>
                                <p>
                                    You may stop using the Platform at any time
                                    by discontinuing access and deleting any
                                    downloaded Brand Assets, subject to any
                                    ongoing obligations (e.g., confidentiality).
                                </p>
                            </li>
                            <li>
                                <span>12.2 By Us</span>
                                <p>
                                    We may terminate or suspend your access to
                                    the Platform immediately, without notice, if
                                    you breach these Terms or for any other
                                    reason at our discretion.
                                </p>
                            </li>
                            <li>
                                <span>12.3 Effect of Termination</span>
                                <p>
                                    Upon termination, your license to use the
                                    Brand Assets ends, and you must cease all
                                    use and destroy any copies in your
                                    possession. Sections 7, 9, 10, 11, and 14
                                    survive termination.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>
                            13. Governing Law and Dispute Resolution
                        </strong>
                        <ol>
                            <li>
                                <span>13.1 Governing Law</span>
                                <p>
                                    These Terms are governed by the laws of Hong
                                    Kong Special Administrative Region, without
                                    regard to conflict of law principles.
                                </p>
                            </li>
                            <li>
                                <span>13.2 Dispute Resolution</span>
                                <p>
                                    Any disputes arising from these Terms will
                                    be resolved through binding arbitration in
                                    Hong Kong, conducted under the rules of the
                                    Hong Kong International Arbitration Centre
                                    (HKIAC) . You waive any right to participate
                                    in a class action lawsuit or jury trial.
                                    Notwithstanding this, we may seek injunctive
                                    relief in any court to protect our
                                    intellectual property or confidential
                                    information.
                                </p>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>14. Miscellaneous</strong>
                        <ol>
                            <li>
                                <span>14.1 Severability</span>
                                <p>
                                    If any provision of these Terms is found
                                    unenforceable, the remaining provisions will
                                    remain in full effect.
                                </p>
                            </li>
                            <li>
                                <span>14.2 No Waiver</span>
                                <p>
                                    Our failure or decision not to enforce any
                                    right or provision does not constitute a
                                    waiver of that right or provision.
                                </p>
                            </li>
                            <li>
                                <span>14.3 Explanation</span>
                                <p>
                                    The rights of final explanation for the
                                    Terms remain with us.
                                </p>
                            </li>
                            <li>
                                <span>14.4 Effective Date</span>
                                <p>
                                    This version of the Terms comes into effect
                                    from [15th] [May] [2025].
                                </p>
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    );
}
